import { render, staticRenderFns } from "./ListActiveDetail.vue?vue&type=template&id=71994ffc&scoped=true&"
import script from "./ListActiveDetail.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71994ffc",
  null
  
)

export default component.exports